import { render, staticRenderFns } from "./FirstSection.vue?vue&type=template&id=24e3e6f8&scoped=true&"
import script from "./FirstSection.vue?vue&type=script&lang=js&"
export * from "./FirstSection.vue?vue&type=script&lang=js&"
import style0 from "./FirstSection.vue?vue&type=style&index=0&id=24e3e6f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3e6f8",
  null
  
)

export default component.exports